const STATUS_FILTER_OPTIONS = [
  { label: 'All', id: 'all' },
  { label: 'Published', id: 'published' },
  { label: 'New', id: 'new' },
];

const HAZARD_CATEGORIES = [
  {
    label: 'Dry spell',
    id: 'dry-spell',
  },
  {
    label: 'Extreme rainfall',
    id: 'extreme-precipitation',
  },
  {
    label: 'Floods',
    id: 'floods',
  },
  {
    label: 'Heat wave',
    id: 'heat-wave',
  }, {
    label: 'Fire',
    id: 'fire',
  },
  {
    label: 'Extreme wind',
    id: 'extreme-wind',
  },
  {
    label: 'Tropical cyclones',
    id: 'tropical-cyclones',
  },
];

export {
  STATUS_FILTER_OPTIONS,
  HAZARD_CATEGORIES,
};